const PERIODICITY_LABELS: Record<string, string> = {
  DAILY: 'Diária',
  WEEKLY: 'Semanal',
  BIWEEKLY: 'Quinzenal',
  MONTHLY: 'Mensal',
  CUSTOM: 'Personalizada',
};

export const getPeriodicityLabel = (periodicity: string, customDays?: number): string => {
  if (periodicity === 'CUSTOM' && customDays) {
    return `A cada ${customDays} ${customDays === 1 ? 'dia' : 'dias'}`;
  }
  return PERIODICITY_LABELS[periodicity] ?? 'Não definida';
};
